import React from 'react';
import DefaultView from 'components/ui/DefaultView';
import SingleUnsubscriptionSection from './SingleUnsubscriptionSection';
import DomainUnsubscriptionSection from './DomainUnsubscriptionSection';
import AppRoute from 'components/AppRoute';

const Content = () => (
  <>
    <SingleUnsubscriptionSection />
    <DomainUnsubscriptionSection />
  </>
);

const UnSubscription = () => {
  return (
    <DefaultView>
      <AppRoute component={Content} path="/" permission="unsubscription.view" />
    </DefaultView>
  );
};

export default UnSubscription;
